// ─────────────────────────────────────────────────────────────────────────────
// Module gomulu, host'tan bagimsiz mini i18n. Varsayilan dil: tr.
// react-i18next gerekmez; baska projeye kopyalayinca da calisir.
// Dili degistirmek icin: setLogoLang('en').
// ─────────────────────────────────────────────────────────────────────────────

type Lang = 'tr' | 'en';

const dict: Record<Lang, Record<string, string>> = {
  tr: {
    logoCustomers: 'Logo Cari',
    newCustomer: 'Yeni Cari',
    refresh: 'Yenile',
    search: 'Ara',
    save: 'Kaydet',
    cancel: 'Vazgec',
    onlyActive: 'Sadece aktif',
    code: 'Kod',
    title: 'Unvan',
    cardType: 'Kart Tipi',
    city: 'Sehir',
    phone: 'Telefon',
    email: 'E-posta',
    vatId: 'Vergi No',
    taxOffice: 'Vergi Dairesi',
    address: 'Adres',
    contact: 'Yetkili',
    active: 'Aktif',
    passive: 'Pasif',
    status: 'Durum',
    general: 'Genel',
    addressTab: 'Adres',
    finance: 'Finans',
    creditLimit: 'Kredi Limiti',
    groupCode: 'Grup Kodu',
    selectCustomer: 'Detay icin bir cari secin',
    selectRecord: 'Detay icin bir kayit secin',
    newRecord: 'Yeni Kayit',
    noData: 'Kayit yok',
    send: 'Logo\'ya Gonder',
    savedOk: 'Cari Logo\'ya gonderildi',
    saveError: 'Kayit basarisiz',
    loadError: 'Liste yuklenemedi',
    connecting: 'Logo oturumu aciliyor...',
    notConnected: 'Logo baglantisi yok',
  },
  en: {
    logoCustomers: 'Logo Customers',
    newCustomer: 'New Customer',
    refresh: 'Refresh',
    search: 'Search',
    save: 'Save',
    cancel: 'Cancel',
    onlyActive: 'Only active',
    code: 'Code',
    title: 'Title',
    cardType: 'Card Type',
    city: 'City',
    phone: 'Phone',
    email: 'Email',
    vatId: 'VAT No',
    taxOffice: 'Tax Office',
    address: 'Address',
    contact: 'Contact',
    active: 'Active',
    passive: 'Passive',
    status: 'Status',
    general: 'General',
    addressTab: 'Address',
    finance: 'Finance',
    creditLimit: 'Credit Limit',
    groupCode: 'Group Code',
    selectCustomer: 'Select a customer to view details',
    selectRecord: 'Select a record to view details',
    newRecord: 'New Record',
    noData: 'No records',
    send: 'Send to Logo',
    savedOk: 'Customer sent to Logo',
    saveError: 'Save failed',
    loadError: 'Failed to load list',
    connecting: 'Opening Logo session...',
    notConnected: 'No Logo connection',
  },
};

let lang: Lang = 'tr';

export function setLogoLang(l: Lang): void {
  if (l in dict) lang = l;
}

/** Ceviri fonksiyonu. Anahtar yoksa anahtarin kendisini doner. */
export function lt(key: string): string {
  return dict[lang][key] ?? key;
}
